import { useVehicle } from '@motorway/motorway-handshake-components';

import { Damage } from './Damage';

export const DamageWrapper = () => {
  const { vehicle: { sellerPrep } } = useVehicle();
  const { prepItems } = sellerPrep ?? {};

  return <Damage prepItems={prepItems} />;
};
